import { createSlice } from "@reduxjs/toolkit";

const availableBalanceSlice = createSlice({
    name: "availableBalance",
    initialState: {
        txnStartDate: null,
        txnEndDate: null,
    },
    reducers: {
        setTxnStartDate: (state, { payload }) => {
            state.txnStartDate = payload;
        },
        setTxnEndDate: (state, { payload }) => {
            state.txnEndDate = payload;
        },
    }
});

export const { setTxnStartDate, setTxnEndDate } = availableBalanceSlice.actions;

export default availableBalanceSlice.reducer;